<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { storeToRefs } from 'pinia';

import { useSupportPlanGoalStore } from '@/stores/supportPlanGoal';
import { useOptionsStore } from '@/stores/options';

const emit = defineEmits(['close-modal']);

const { storeSupportPlanGoal, updateSupportPlanGoal } = useSupportPlanGoalStore();
const { responsiblePartyOptions, supportPlanGoalOutcomes } = storeToRefs(useOptionsStore());

const props = defineProps({
    goal: {
        type: Object,
        default: () => ({})
    },

    supportPlan: {
        type: Object,
        required: true
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const form = ref({
    ...props.goal,
    support_plan_id: props.supportPlan.id,
    managers: (props.goal.managers || []).map((manager) => manager.id),
    outcome: props.goal.outcome ? props.goal.outcome.id : null,
});

const save = async () => {
    const action = props.mode === 'Create' ? storeSupportPlanGoal : updateSupportPlanGoal;

    await action({
        ...form.value,
        support_plan_type_id: props.supportPlan.type.id,
    });

    emit('close-modal');
};

const cancel= () => {
    emit('close-modal');
};

</script>

<template>
<ModalWrapper>
    <template #header>{{ $t('label.modal_title', { mode: mode, what: 'Goal'}) }}</template>
    <template #subheader>{{ $t('label.create_or_edit', { what: 'the goal of current support plan'}) }}</template>
    <form @submit.prevent="save">
        <div class="md:grid md:grid-cols-2 md:gap-4">
            <StyledInput
                v-model="form.description"
                class="col-span-2"
                :placeholder="$t('label.goal_description')"
                name="description"
                :label="$t('label.goal')" />
            <!-- WSP does not need outcome within goal creation -->
            <StyledDropdown
                v-if="supportPlan.type.name == 'ISP (Individual Support Plan)'"
                v-model="form.outcome"
                :placeholder="$t('label.outcome')"
                name="outcome"
                :options="supportPlanGoalOutcomes"
                :label="$t('label.outcome')" />
            <StyledAutoComplete
                v-if="supportPlan.type.name == 'ISP (Individual Support Plan)'"
                v-model="form.managers"
                :options="responsiblePartyOptions"
                name="managers"
                :searchable="true"
                :clearable="true"
                :multiple="true"
                :label="$t('label.responsible_party')"
                :placeholder="$t('label.select_responsible_party')" />
        </div>
    </form>
    <template #footer>
        <StyledSaveButton @save="save" @cancel="cancel" />
    </template>
</ModalWrapper>
</template>
